<template>
  <div id='calendar'></div>
</template>

<script>
export default {
  props: {
    defaultDate: { type: String, default: window.moment().format('YYYY-MM-DD') },
    editable: { type: Boolean, default: false },
    eventLimit: { type: Boolean, default: true },
    events: { type: Array, required: true },
    defaultView: { type: String, default: 'agendaDay' }
  },
  watch: {
    events: {
      handler: function () {
        $(this.$el).fullCalendar('removeEvents')
        $(this.$el).fullCalendar('addEventSource', this.events)
      },
      deep: true
    }
  },
  mounted () {
    this.initFullCalender()
  },
  methods: {
    initFullCalender () {
      this.$nextTick(() => {
        $('#calendar').fullCalendar({
          header: {
            left: 'prev,next today',
            center: 'title',
            right: 'month,agendaWeek,agendaDay,basic'
          },
          defaultDate: this.default,
          editable: this.editable,
          eventLimit: this.eventLimit,
          eventRender: function (event, element) {
            element.popup({
              title: event.title,
              content: event.msg,
              transition: 'horizontal flip',
              inline: false,
              hoverable: true,
              position: 'top center',
              delay: {
                show: 100,
                hide: 150
              }
            })
          },
          events: this.events
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/abstract_components/FullCalendar.vue